import http from '@/helpers/Http';

export default {
    namespaced: true,
    state: {
        items: [],
        uad: [],
        item: {},
    },
    getters: {
        items: state => state.items,
        item: state => state.item,
        uad: state => state.uad,
    },
    mutations: {
        setItems(state, items) {
            state.items = items;
        },
        setItem(state, item) {
            state.item = item;
        },
        setUad(state, uad) {
            state.uad = uad;
        },
    },
    actions: {        
        async edit({ commit, rootState }, id) {
            const response = await http.get(`pbxware/extensions/${id}/edit`, {
                params: {
                    server_id: rootState.route.meta.serverId
                }
            });

            commit('setItem', response.data);

            return response;
        },
        async update({ commit, rootState }, payload) {
            payload.server_id = rootState.route.meta.serverId;
            const response = await http.patch(`pbxware/extensions/${payload.id}`, payload);

            commit('setItem', response.data);

            return response;
        },
        async store({ commit, rootState }, payload) {
            payload.server_id = rootState.route.meta.serverId;
            const response = await http.post(`pbxware/extensions`, payload);

            return response;
        },
        async delete({ commit, rootState }, id) {
            const response = await http.delete(`pbxware/extensions/${id}`, {
                params: {server_id: rootState.route.meta.serverId}
            });

            return response;
        }
    }
}